import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss']
})
export class ImageDialogComponent implements OnInit {
  title: string;
  message: string;
  img: string;
  buttonText: string;
  buttonColor: "primary" | "accent" | "warn";
  titleColor: string;
  imageIsLoaded = false;

  constructor(
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title || 'Information';
    this.message = data.message || '';
    this.img = data.img || 'assets/imgs/404-img.png';
    this.buttonText = data.buttonText || 'OK';
    this.buttonColor = data.buttonColor || 'primary';
    this.titleColor = data.titleColor || '#333333';
  }

  ngOnInit(): void {
  }

  imageLoaded(): void {
    this.imageIsLoaded = true;
  }

  close(): void {
    this.dialogRef.close(this.data.result);
  }
}
